import React, { useState } from 'react';
import { useLocation, Link } from 'react-router-dom';
import { grantAnalyticsConsent, denyAnalyticsConsent } from './analytics';

const CONSENT_KEY = 'smcla_analytics_consent';

export default function CookieConsentBanner() {
  const { pathname } = useLocation();
  const [dismissed, setDismissed] = useState(false);

  // Hide if already decided or just dismissed
  if (dismissed || localStorage.getItem(CONSENT_KEY) !== null) return null;

  const handleAccept = () => {
    grantAnalyticsConsent(pathname);
    setDismissed(true);
  };

  const handleDeny = () => {
    denyAnalyticsConsent();
    setDismissed(true);
  };

  return (
    <div style={{
      position: 'fixed',
      bottom: 0,
      left: 0,
      right: 0,
      zIndex: 9999,
      backgroundColor: '#13131f',
      borderTop: '1px solid rgba(255,255,255,0.08)',
      padding: '16px 24px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: 16,
      flexWrap: 'wrap',
    }}>
      <p style={{
        margin: 0,
        fontFamily: 'Inter, system-ui, sans-serif',
        fontSize: 13,
        color: '#9499b0',
        lineHeight: 1.6,
        flex: 1,
        minWidth: 200,
      }}>
        We use analytics to understand how visitors use this site. No personal data is sold or shared.{' '}
        <Link to="/privacy-policy" style={{ color: '#5ce1e6', textDecoration: 'none' }}>
          Privacy Policy
        </Link>
      </p>

      <div style={{ display: 'flex', gap: 10, flexShrink: 0 }}>
        <button
          onClick={handleDeny}
          style={{
            fontFamily: 'Inter, system-ui, sans-serif',
            fontWeight: 600,
            fontSize: 13,
            color: '#9499b0',
            background: 'transparent',
            border: '1px solid rgba(255,255,255,0.15)',
            borderRadius: 6,
            padding: '8px 16px',
            cursor: 'pointer',
          }}
        >
          Deny
        </button>
        <button
          onClick={handleAccept}
          style={{
            fontFamily: 'Inter, system-ui, sans-serif',
            fontWeight: 700,
            fontSize: 13,
            color: '#0a0a12',
            background: '#5ce1e6',
            border: 'none',
            borderRadius: 6,
            padding: '8px 16px',
            cursor: 'pointer',
          }}
        >
          Accept
        </button>
      </div>
    </div>
  );
}
